var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"8px"}},[(_vm.isLoading)?_c('b-spinner',{attrs:{"variant":"warning","small":""}}):(!_vm.isLoading)?_c('toggle-button',{attrs:{"color":"#38BA6D","width":40,"height":20},on:{"change":_vm.toggle},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }